import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { getJoininURL, getSettleURL } from '@/common/utils'
import { Modal } from '@sailor/keeta-design-pc'
import { getSettledShopListApi } from '@/common/api/shopInfoApi'
import { getInWindowsApp, getIsOrderManager } from '@RootCommon/utils'

export default function NoSettledShopModal () {
  const { t } = useTranslation()

  const [hasSettledClue, setHasSettledClue] = useState(false)
  const [visible, setVisible] = useState(false)

  const isAllUnValidSettledShop = useCallback(async () => {
    try {
      const settledShopList = await getSettledShopListApi()
      // 如果自入驻门店列表不为空，则返回自入驻线索列表中没有有效的自入驻门店
      return settledShopList?.length && settledShopList.every(item => !item.shopId)
    } catch (e) {
      console.error(e)
    }
    return false
  }, [])

  useEffect(() => {
    isAllUnValidSettledShop().then(isAllUnValidSettledShop => {
      setHasSettledClue(isAllUnValidSettledShop)
      setVisible(true)
    })
  }, [isAllUnValidSettledShop])

  function handleGoSet () {
    const isInWindowsApp = getInWindowsApp()
    const isOrderManager = getIsOrderManager()
    const isInOrderWindowsApp = isInWindowsApp && isOrderManager

    if (isInOrderWindowsApp) {
      const joininUrl = getJoininURL()
      window.top?.electronAPI.openExternal(joininUrl)
    } else {
      const settleUrl = getSettleURL()
      window.open(settleUrl, '_blank')
    }
  }

  const renderToSettleModal = () => (
    <Modal
      title={t('merchant_login_self_toast_title', 'Account error')}
      visible
      onConfirm={handleGoSet}
      closable={false}
      closeIcon={null}
      showCancelButton={false}
      backdropClosable={false}
      confirmText={t('merchant_login_self_toast_btn', 'Continue onboarding')}
    >
      <div>{t('merchant_login_self_toast', 'Your onboarding process is not complete. Please complete the remaining steps.')}</div>
    </Modal>
  )

  const renderNoShopModal = () => (
    <Modal
      title={t('merchant_login_self_toast_title', 'Account error')}
      visible
      showCancelButton={false}
      closable={false}
      closeIcon={null}
      backdropClosable={false}
      onConfirm={() => setVisible(false)}
      confirmText={t('merchant_login_self_btn_confirm', 'confirm')}
    >
      <div>{t('merchant_login_wrong_toast', 'Your account is not currently linked to any stores. For assistance, please contact your business development consultant.')}</div>
    </Modal>
  )


  return visible && (hasSettledClue ? renderToSettleModal() : renderNoShopModal())
}
